module.exports = __webpack_public_path__ + "images/stickers/pete-music.81712ae4a84debcd6333.png";